import { UnleashClient } from 'unleash-proxy-client';

const unleash = new UnleashClient({
  url: 'https://eu.app.unleash-hosted.com/eubb1018/api/frontend',
  clientKey: process.env.UNLEASH_FRONTEND_KEY || 'dummy',
  appName: '7s-portal',
});

export default unleash;
